import styled from 'styled-components';
import { Typography, withStyles } from '@material-ui/core';

export default withStyles({}, { withTheme: true })(styled(Typography)`
    color: ${(props)=> props.error === 'true' && props.theme.palette.error.main};
`);
